<template>
  <b-container fluid>
    <b-row align-h="center">
      <b-col cols="8">
        <h2 class="header">Zipcodes management</h2>
        <p>An email containing CSV with all zip codes sorted by country code will be sent to the <b>se-sales@aroundhome.de</b>.</p>
        <NotificationContainer v-if="!!message" :message = "message"/>
        <ErrorsContainer class="errors-container" :errors = "errors"/>
        <b-button v-promise-btn @click="exportZipcodes" variant="success">Export Zip Codes</b-button>
      </b-col>
    </b-row>
  </b-container>
</template>

<script>
import ZipcodesProvider from '@/services/ZipcodesProvider'
import NotificationContainer from '@/components/NotificationContainer'
import ErrorsContainer from '@/components/ErrorsContainer'

export default {
  name: 'ZipcodesManagement',
  data () {
    return {
      message: '',
      errors: []
    }
  },
  components: {
    NotificationContainer,
    ErrorsContainer
  },
  methods: {
    exportZipcodes () {
      return new Promise((resolve, reject) => {
        ZipcodesProvider.exportViaEmail()
          .then((resp) => {
            this.message = 'Email with zip codes was sent.'
            resolve(resp)
          }, (resp) => {
            this.errors = resp.body.errors
            resolve(resp)
          })
      })
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.header {
  margin-top: 25px;
  margin-bottom: 25px;
}

.errors-container {
  margin-bottom: 15px;
}
</style>
